import {
  Logout,
  SetAuthToken,
  SetIsTokenSignIn,
  SignInPhone,
  SetValidateLockedUntil,
} from 'src/constants/actionTypes'
import { authService } from 'src/services/AuthService'
import { Action } from 'src/utils/reduxUtils'
import { AuthState } from './types'

const getInitialState = (): AuthState => ({
  authToken:
    authService.getStoredAuthToken() ||
    // fallback to legacy keys for users who haven't migrated yet
    authService.getStoredOnboardingToken() ||
    authService.getStoredRecollectionToken(),
  isTokenSignIn: authService.getStoredIsTokenSignIn(),

  resendAvailableAt: null,
  resendRemainingCount: null,
  validateLockedUntil: null,
  attemptsRemaining: null,
})

export const authReducer = (
  state: AuthState = getInitialState(),
  action: Action<any>,
): AuthState => {
  switch (action.type) {
    case SignInPhone.type.SUCCESS:
      return {
        ...state,
        resendAvailableAt: action.payload.resendAvailableAt,
        resendRemainingCount: action.payload.resendRemainingCount,
        validateLockedUntil: action.payload.validateLockedUntil,
        attemptsRemaining: action.payload.attemptsRemaining,
      }
    case SetAuthToken.type.SUCCESS:
      return {
        ...state,
        authToken: action.payload,

        resendAvailableAt: null,
        resendRemainingCount: null,
        validateLockedUntil: null,
        attemptsRemaining: null,
      }
    case SetIsTokenSignIn.type.SUCCESS: {
      return {
        ...state,
        isTokenSignIn: action.payload,
      }
    }
    case SetValidateLockedUntil.type.SUCCESS:
      return {
        ...state,
        validateLockedUntil: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
